import { render, staticRenderFns } from "./CampaignPaymentsTable.vue?vue&type=template&id=3090e909&"
import script from "./CampaignPaymentsTable.vue?vue&type=script&lang=js&"
export * from "./CampaignPaymentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports